/* ============================================================
   URBANLUX — CRO JS v2
   Conversión, UX y comportamiento premium
   ============================================================ */
(function () {
  'use strict';

  /* ---- UTILIDADES ---- */
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const qs = s => sessionStorage.getItem(s);
  const ss = (s, v) => { try { sessionStorage.setItem(s, v); } catch(e){} };

  /* ============================================================
     1. ANNOUNCEMENT BAR — Rotatorio con cierre
     ============================================================ */
  function initAnnouncement() {
    if ($('.ul-announcement') || qs('ul-bar-closed')) return;
    const msgs = [
      '🚀 Lanzamiento UrbanLux — <strong>Envío gratis</strong> en todos los pedidos',
      '📦 Envío con <strong>seguimiento</strong> en todos los pedidos',
      '🔒 Pago 100% seguro · Devolución <strong>30 días</strong> sin preguntas',
      '✨ Pack Completo — <strong>Ahorra 76€</strong> frente a comprar por separado'
    ];
    let idx = 0;
    const bar = document.createElement('div');
    bar.className = 'ul-announcement';
    bar.innerHTML = `
      <div class="ul-announcement-inner">
        <span class="ul-announcement-msg">${msgs[0]}</span>
        <button class="ul-announcement-close" aria-label="Cerrar">&#215;</button>
      </div>`;
    document.body.insertBefore(bar, document.body.firstChild);
    const msg = bar.querySelector('.ul-announcement-msg');
    bar.querySelector('.ul-announcement-close').addEventListener('click', () => {
      bar.style.maxHeight = bar.offsetHeight + 'px';
      bar.style.transition = 'max-height .4s ease, opacity .3s ease';
      requestAnimationFrame(() => { bar.style.maxHeight = '0'; bar.style.opacity = '0'; });
      setTimeout(() => bar.remove(), 450);
      ss('ul-bar-closed', '1');
    });
    setInterval(() => {
      msg.style.opacity = '0';
      setTimeout(() => {
        idx = (idx + 1) % msgs.length;
        msg.innerHTML = msgs[idx];
        msg.style.transition = 'opacity .4s';
        msg.style.opacity = '1';
      }, 350);
    }, 5000);
    msg.style.transition = 'opacity .4s';
  }

  /* ============================================================
     2. TRUST BAR — Debajo del header
     ============================================================ */
  function initTrustBar() {
    if ($('.ul-trust-bar')) return;
    const bar = document.createElement('div');
    bar.className = 'ul-trust-bar';
    bar.setAttribute('role', 'complementary');
    bar.setAttribute('aria-label', 'Garantías de compra');
    bar.innerHTML = `
      <div class="ul-trust-item"><span class="ul-trust-icon" aria-hidden="true">✈️</span><span>Envío <strong>gratis</strong> +30€</span></div>
      <div class="ul-trust-sep" aria-hidden="true"></div>
      <div class="ul-trust-item"><span class="ul-trust-icon" aria-hidden="true">↩️</span><span>Devolución <strong>30 días</strong></span></div>
      <div class="ul-trust-sep" aria-hidden="true"></div>
      <div class="ul-trust-item"><span class="ul-trust-icon" aria-hidden="true">🔒</span><span>Pago <strong>100% seguro</strong></span></div>
      <div class="ul-trust-sep" aria-hidden="true"></div>
      <div class="ul-trust-item"><span class="ul-trust-icon" aria-hidden="true">⚡</span><span>Envío con <strong>seguimiento</strong></span></div>`;
    const header = $('header, .header-wrapper, #shopify-section-header');
    if (header) header.insertAdjacentElement('afterend', bar);
  }

  /* ============================================================
     4. GUARANTEE STRIP debajo del botón
     ============================================================ */
  function initGuaranteeStrip() {
    if (!location.pathname.includes('/products/') || $('.ul-guarantee-strip')) return;
    const btn = $('[name="add"], .product-form__submit');
    if (!btn) return;
    const strip = document.createElement('div');
    strip.className = 'ul-guarantee-strip';
    strip.innerHTML = `
      <div class="ul-guarantee-item"><span class="ul-guarantee-icon" aria-hidden="true">🛡️</span>Garantía UrbanLux</div>
      <div class="ul-guarantee-item"><span class="ul-guarantee-icon" aria-hidden="true">↩️</span>Devolución 30 días</div>
      <div class="ul-guarantee-item"><span class="ul-guarantee-icon" aria-hidden="true">📦</span>Envío con seguimiento</div>
      <div class="ul-guarantee-item"><span class="ul-guarantee-icon" aria-hidden="true">🔒</span>Pago seguro</div>`;
    const form = btn.closest('form') || btn.parentElement;
    form.insertAdjacentElement('afterend', strip);
  }

  /* ============================================================
     5. STICKY ADD TO CART — móvil
     ============================================================ */
  function initStickyATC() {
    if (!location.pathname.includes('/products/') || !window.matchMedia('(max-width:768px)').matches) return;
    const mainBtn = $('[name="add"], .product-form__submit');
    const titleEl = $('h1.product__title, .product__title, h1');
    const priceEl = $('.price-item--sale, .price__current, .price-item--regular');
    if (!mainBtn || !titleEl) return;
    const sticky = document.createElement('div');
    sticky.className = 'ul-sticky-atc';
    sticky.setAttribute('aria-hidden', 'true');
    sticky.innerHTML = `
      <span class="ul-sticky-product-name">${titleEl.textContent.trim()}</span>
      <span class="ul-sticky-price">${priceEl ? priceEl.textContent.trim() : ''}</span>
      <button class="ul-sticky-btn">Añadir al carrito</button>`;
    document.body.appendChild(sticky);
    sticky.querySelector('.ul-sticky-btn').addEventListener('click', () => {
      mainBtn.click();
      sticky.querySelector('.ul-sticky-btn').textContent = '✓ Añadido';
      setTimeout(() => sticky.querySelector('.ul-sticky-btn').textContent = 'Añadir al carrito', 2000);
    });
    const io = new IntersectionObserver(([e]) => {
      sticky.classList.toggle('visible', !e.isIntersecting);
      sticky.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
    }, { threshold: 0 });
    io.observe(mainBtn);
  }

  /* ============================================================
     6. HEADER SCROLL — Sombra al bajar
     ============================================================ */
  function initHeaderScroll() {
    const header = $('header, .header-wrapper');
    if (!header) return;
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          header.classList.toggle('scrolled', window.scrollY > 40);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ============================================================
     7. SMOOTH IMAGE LOAD
     ============================================================ */
  function initSmoothImages() {
    $$('img[loading="lazy"]').forEach(img => {
      if (img.complete) return;
      img.style.opacity = '0';
      img.style.transition = 'opacity .45s ease';
      img.addEventListener('load', () => { img.style.opacity = '1'; }, { once: true });
    });
  }

  /* ============================================================
     8. PRECIO COMPARATIVO — Badge de ahorro dinámico
     ============================================================ */
  function initSavingsBadge() {
    if (!location.pathname.includes('/products/')) return;
    const sale = $('.price-item--sale');
    const compare = $('.price-item--compare');
    if (!sale || !compare || $('.ul-price-save')) return;
    const parsePrice = el => parseFloat(el.textContent.replace(/[^0-9,.]/g,'').replace(',','.'));
    const saleVal = parsePrice(sale);
    const compareVal = parsePrice(compare);
    if (isNaN(saleVal) || isNaN(compareVal) || compareVal <= saleVal) return;
    const saving = Math.round(compareVal - saleVal);
    const pct = Math.round((saving / compareVal) * 100);
    const badge = document.createElement('span');
    badge.className = 'ul-price-save';
    badge.textContent = `Ahorras ${saving}€ (−${pct}%)`;
    compare.insertAdjacentElement('afterend', badge);
  }

  /* ============================================================
     9. SCHEMA.ORG — Producto
     ============================================================ */
  function injectProductSchema() {
    if (!location.pathname.includes('/products/')) return;
    const title = $('h1.product__title, h1');
    const price = $('.price-item--sale, .price__current, .price-item--regular');
    const img = $('.product__media img, .product-gallery img');
    const desc = $('.product__description, .product-description');
    if (!title || !price) return;
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: title.textContent.trim(),
      description: desc ? desc.textContent.trim().slice(0, 300) : '',
      image: img ? [img.src] : [],
      brand: { '@type': 'Brand', name: 'UrbanLux' },
      offers: {
        '@type': 'Offer',
        priceCurrency: 'EUR',
        price: price.textContent.replace(/[^0-9,.]/g,'').replace(',','.') || '0',
        availability: 'https://schema.org/InStock',
        seller: { '@type': 'Organization', name: 'UrbanLux' },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: { '@type': 'MonetaryAmount', value: '0', currency: 'EUR' }
        }
      }
    };
    const s = document.createElement('script');
    s.type = 'application/ld+json';
    s.textContent = JSON.stringify(schema);
    document.head.appendChild(s);
  }

  /* ============================================================
     10. ORGANIZATION SCHEMA
     ============================================================ */
  function injectOrgSchema() {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'UrbanLux',
      url: 'https://urbanlux.es',
      logo: 'https://cdn.shopify.com/s/files/1/0771/7362/1003/files/logo-urbanlux-monograma.png',
      contactPoint: { '@type': 'ContactPoint', email: 'urbanlux30@gmail.com',
        contactType: 'customer service', availableLanguage: 'Spanish' },
      sameAs: [
        'https://www.instagram.com/urbanlux.es',
        'https://www.tiktok.com/@urbanlux71',
        'https://www.facebook.com/urbanlux.es'
      ]
    };
    const s = document.createElement('script');
    s.type = 'application/ld+json';
    s.textContent = JSON.stringify(schema);
    document.head.appendChild(s);
  }

  /* ============================================================
     11. WEBSITE SEARCH SCHEMA
     ============================================================ */
  function injectWebsiteSchema() {
    if (location.pathname !== '/') return;
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'UrbanLux',
      url: 'https://urbanlux.es',
      potentialAction: {
        '@type': 'SearchAction',
        target: { '@type': 'EntryPoint', urlTemplate: 'https://urbanlux.es/search?q={search_term_string}' },
        'query-input': 'required name=search_term_string'
      }
    };
    const s = document.createElement('script');
    s.type = 'application/ld+json';
    s.textContent = JSON.stringify(schema);
    document.head.appendChild(s);
  }

  /* ============================================================
     12. BACK TO TOP BUTTON
     ============================================================ */
  function initBackToTop() {
    const btn = document.createElement('button');
    btn.className = 'ul-back-top';
    btn.innerHTML = '↑';
    btn.setAttribute('aria-label', 'Volver arriba');
    btn.style.cssText = `
      display:none;position:fixed;bottom:24px;right:24px;z-index:997;
      width:40px;height:40px;background:var(--ul-obsidian);
      color:var(--ul-ivory);border:1px solid rgba(201,169,154,.2);
      font-size:16px;cursor:pointer;
      transition:opacity .3s,transform .3s;
      font-family:var(--ul-font-mono);
    `;
    document.body.appendChild(btn);
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    window.addEventListener('scroll', () => {
      const show = window.scrollY > 400;
      btn.style.display = show ? 'block' : 'none';
      btn.style.opacity = show ? '1' : '0';
    }, { passive: true });
  }

  /* ============================================================
     INIT — Ejecutar en orden correcto
     ============================================================ */
  function boot() {
    initAnnouncement();
    initTrustBar();
    injectOrgSchema();
    injectWebsiteSchema();
    initHeaderScroll();
    initSmoothImages();
    initBackToTop();
  }

  function bootDom() {
    initGuaranteeStrip();
    initStickyATC();
    injectProductSchema();
    initSavingsBadge();
  }

  /* Ejecutar inmediatamente lo que no necesita DOM */
  boot();

  /* Esperar DOM para el resto */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootDom);
  } else {
    bootDom();
  }

})();